var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text-body-2 text-secondary--text",
      attrs: { "data-qa": "analyses_meta_h1_subtitle" },
    },
    [
      !_setup.equipOpenType ? [_vm._v("\n    Где сделать\n  ")] : _vm._e(),
      _vm._v("\n  " + _vm._s(_setup.serviceNameVin) + "\n  "),
      _setup.equipOpenType ? [_vm._v("\n    открытого типа\n  ")] : _vm._e(),
      _vm._v(
        "\n  " +
          _vm._s(_setup.locationText) +
          ":\n  " +
          _vm._s(_setup.totalObjects) +
          "\n  " +
          _vm._s(_setup.clinicsWord) +
          "\n  с адресами\n  "
      ),
      _setup.hasPrice
        ? [
            _vm._v("\n    и ценами\n    от "),
            _c("span", { attrs: { itemprop: "lowPrice" } }, [
              _vm._v(_vm._s(_setup.priceMin)),
            ]),
            _vm._v("\n    до "),
            _c("span", { attrs: { itemprop: "highPrice" } }, [
              _vm._v(_vm._s(_setup.priceMax)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                attrs: {
                  itemprop: "priceCurrency",
                  content: _setup.currencyIso,
                },
              },
              [_vm._v(" " + _vm._s(_setup.currencyGenitive))]
            ),
            _vm._v(",\n  "),
          ]
        : _vm._e(),
      _vm._v(
        "\n  запись на " +
          _vm._s(_setup.serviceNameVin) +
          ', фотографии и характеристики оборудования.\n  При выборе клиники можно ознакомиться с отзывами других пациентов,\n  которые уже воспользовались услугами\n  "' +
          _vm._s(_setup.serviceName) +
          '"\n  в данных медицинских центрах ' +
          _vm._s(_setup.townNameRod) +
          ".\n"
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }